import React,{useState, useEffect, useRef} from 'react';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {Inc,Story} from './Inc';
import Ajax from './Ajax';
import Publish from './Publish';
import Loading from './Loading';
import './Edit.scss';

interface Props {
    uid:string,
    save(id:string):void,
    move(str:string):void,
    story:Story;
}

interface Edit {
    id: number,
    title: string,
    lines: string[],
    group_id: number,
}

const Edit = (props:Props)=> {
    Ajax.setUid(props.uid);

    const inputRef = useRef<HTMLInputElement>(null);

    let defEdit:Edit = {
        id: 0,
        title: "",
        lines: [""],
        group_id: 0,
    }
    if( props.story && props.story.id>0 ){
        defEdit.id = props.story.id;
        defEdit.title = props.story.title;
        defEdit.lines = props.story.lines.split("\n");
        defEdit.group_id = props.story.group_id;
    }
    const [states,setStates] = useState({
        modalPage:"",
        edit: defEdit,
        lineNo: 0,
        posNo: 0,
        isModal:false,
        isPublish:false,
        isLoading:false,
    })

    /*
    const handleModalClose = ()=>{
        setStates({...states,"isModal":false});
    };
    */
    const change = (name: keyof Edit) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setStates({...states,edit:{...states.edit,[name]:event.target.value}});
    }
    const changeLine = (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
        //console.log("changeline");
        const lines = states.edit.lines;
        let line = event.target.value;
        line = line.replace("-","ー");
        line = line.replace("ー","ー");
        line = line.replace("―","ー");
        line = line.replace("－","ー");
        line = line.replace(",","、");
        line = line.replace("!","！");
        line = line.replace("?","？");
        line = line.replace("&","＆");
        line.replace(/[0-9]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) + 65248);
        });
        setStates({...states,edit:{...states.edit,"lines":lines.slice(0,index).concat(line).concat(lines.slice(index+1))}});
    }
    const keypress = (event:any)=>{
        //console.log("keypress");
        if (event.nativeEvent.keyCode === 13){
            const lines = states.edit.lines;
            const index = states.lineNo;

            const line1 = lines[index].substr(0,event.target.selectionStart);
            const line2 = lines[index].substr(event.target.selectionStart);

            setStates({...states,edit:{...states.edit,"lines":lines.slice(0,index).concat(line1).concat(line2).concat(lines.slice(index+1))},lineNo:states.lineNo+1,posNo:0});
        } else {
            //console.log("keypress",event.nativeEvent.keyCode);
        }
    }
    const keydown = (event:any)=>{
        let pos = event.target.selectionStart;
        if (event.nativeEvent.keyCode===38){
            event.preventDefault();
            if(states.lineNo>0){
                if( pos>states.edit.lines[states.lineNo-1].length ){
                    pos=states.edit.lines[states.lineNo-1].length;
                }
                setStates({...states,lineNo:states.lineNo-1,posNo:pos});
            }
        } else if (event.nativeEvent.keyCode===40 ){
            event.preventDefault();
            if( states.lineNo<states.edit.lines.length-1 ){
                if( pos>states.edit.lines[states.lineNo+1].length ){
                    pos=states.edit.lines[states.lineNo+1].length;
                }
                setStates({...states,lineNo:states.lineNo+1,posNo:pos});
            }
        } else if (event.nativeEvent.keyCode===37 ){
            if(pos===0 && states.lineNo>0){
                event.preventDefault();
                setStates({...states,lineNo:states.lineNo-1,posNo:states.edit.lines[states.lineNo-1].length});
            }
        } else if (event.nativeEvent.keyCode === 39){
            if( pos===states.edit.lines[states.lineNo].length && states.lineNo<states.edit.lines.length-1 ){
                event.preventDefault();
                setStates({...states,lineNo:states.lineNo+1,posNo:0});
            }
        } else if (event.nativeEvent.keyCode===46){
            if( pos===states.edit.lines[states.lineNo].length && states.lineNo<states.edit.lines.length-1 ){
                event.preventDefault();
                const lines = states.edit.lines;
                const index = states.lineNo;
                setStates({...states,edit:{...states.edit,"lines":lines.slice(0,index).concat(lines[index]+lines[index+1]).concat(lines.slice(index+2))},posNo:lines[index].length});
            }
        } else if (event.nativeEvent.keyCode===8){
            if( pos===0 && states.lineNo>0 ){
                event.preventDefault();
                const lines = states.edit.lines;
                const index = states.lineNo;
                setStates({...states,edit:{...states.edit,"lines":lines.slice(0,index-1).concat(lines[index-1]+lines[index]).concat(lines.slice(index+1))},lineNo:states.lineNo-1,posNo:lines[index-1].length});
            }
        } else {
            //console.log("keydown",event.nativeEvent.keyCode);
        }
    }
    const changeGroupId = (event: React.ChangeEvent<HTMLInputElement>) => {
        setStates({...states,edit:{...states.edit,"group_id":parseInt(event.target.value)}});
    }
    const click = (event: React.MouseEvent<HTMLElement>)=>{
        if( event.currentTarget.dataset.index ){
            setStates({...states,lineNo:parseInt(event.currentTarget.dataset.index)});
        }
    }
    const publishYes = (status:boolean)=>{
        setStates({...states,isLoading:true});
        const lines = states.edit.lines.join("\n");
        Ajax.send("story/add",{...states.edit,lines:lines,status:status},(res:any)=>{
            //console.log("story/add",{...states.edit,lines:lines,status:status},res);
            if( res.ok ){
                //setStates({...states,isPublish:false});
                props.move("archive");
            }
        });
    }
    const publishNo = ()=>{
        setStates({...states,isPublish:false});
    }
    const confirm = ()=>{
        setStates({...states,isPublish:true});
    }
    useEffect( ()=>{
        inputRef && inputRef.current && inputRef.current.focus();
        inputRef && inputRef.current && inputRef.current.setSelectionRange(states.posNo,states.posNo);
    },[states.lineNo,states.posNo]);


    let isError = false;
    let errors:string[] = new Array<string>(states.edit.lines.length).fill("");
    for( let i=0 ; i<errors.length; i++ ){
        if( states.edit.lines[i].length===0 ){

        } else if( states.edit.lines[i].length>11 ){
            errors[i] = "△　１行は１１文字まで。";
            isError = true;
        } else if( !states.edit.lines[i].match(/^[\u30a0-\u30ff\u3040-\u309f０１２３４５６７８９ー！？、。]+$/) ){
            errors[i] = "△　使えない文字が混じってます。"
            isError = true;
        }
    }
    if( states.edit.title.trim()==="" ){
        isError = true;
    }
    if( states.edit.lines[0]==="" && states.edit.lines.length===1 ){
        isError = true;
    }

    return (
		<div id="edit" className="root" >
            <FormControl fullWidth={true}>
                <div className="editLabel">タイトル</div>
                <input type="text" value={states.edit.title} onChange={change("title")} className="editInput" placeholder="１４文字以内"/>
                {states.edit.title.trim()==="" &&
                <div className="inputHelper">△　タイトルは省略できません</div>
                }
                {states.edit.title.length>14 &&
                <div className="inputHelper">△　タイトルは１４文字以内で</div>
                }
            </FormControl>
            <FormControl fullWidth={true}>
                <div className="editLabel">本文</div>
                <div className="editText">
                {states.edit.lines.map((line:string,index:number)=>{
                    const key = "line"+index;
                    if( index===states.lineNo ){
                        return (
                            <React.Fragment key={key}>
                                <input ref={inputRef} type="text" value={line} onClick={click} data-index={index} onChange={changeLine(index)} onKeyPress={keypress} onKeyDown={keydown}/>
                                {errors[index]!=="" && <div className="textHelper">{errors[index]}</div>}
                            </React.Fragment>
                        );
                    } else {
                        return (
                            <React.Fragment key={key}>
                                <input type="text" value={line} onClick={click} data-index={index} onChange={changeLine(index)} onKeyPress={keypress} onKeyDown={keydown}/>
                                {errors[index]!=="" && <div className="textHelper">{errors[index]}</div>}
                            </React.Fragment>
                        );
                    }
                })}
                </div>
                {states.edit.lines[0]==="" && states.edit.lines.length===1 &&
                <div className="inputHelper">△　本文は省略できません</div>
                }
            </FormControl>
            <FormControl fullWidth={true}>
                <div className="editLabel">ジャンル</div>
                <div className="editRadio">
                    <RadioGroup aria-label="group_id" name="group_id" value={states.edit.group_id} onChange={changeGroupId} row>
                        <FormControlLabel value={0} control={<Radio />} label={Inc.groupNames[0]} />
                        <FormControlLabel value={1} control={<Radio />} label={Inc.groupNames[1]} />
                        <FormControlLabel value={2} control={<Radio />} label={Inc.groupNames[2]} />
                        <FormControlLabel value={9} control={<Radio />} label={Inc.groupNames[9]} />
                    </RadioGroup>
                </div>
            </FormControl>

            <div className="nextBtns">
                <Button variant="contained" color="secondary" onClick={confirm} disabled={isError}>保存</Button>
            </div>

            <div className="notice">
                ▼本文に使える文字<br/>
                ひらがな　カタカナ　数字　長音符（ー）　句点（。）　読点（、）　！？<br/>
                ※すべて全角
            </div>

            <Publish yes={publishYes} no={publishNo} isOpen={states.isPublish}/>
            <Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default Edit;